import { isDesktop, isTablet, browserClassName, } from 'utils/ua';
import { body, classList, } from 'utils/dom';
const DOMAIN_PREFIX = 'domain';
function getHostWithoutSubDomain(host){
  const parts = host.split('.');
  if (parts.length === 2) {
    return host;
  }
  return parts.
    slice(-2).
    reduce((acc, curr) => acc + '.' + curr);
}
//'90min' -> 'domain--90min-com'
function encodeDomainName(host){
  const hostWithoutSubDomain = getHostWithoutSubDomain(host)
    .replace('.', '-');
  return `${ DOMAIN_PREFIX }--${ hostWithoutSubDomain }`;
}
export default function initDomainClassifier(){
  const { host, } = window.location;
  const encodedDomainName = encodeDomainName(host);
  classList(body).add(encodedDomainName);
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/domainClassifier.js